import { type CssTransitionProps } from '@mui/base'
import { clsx } from 'clsx'
import { type FC, type PropsWithChildren } from 'react'

import { UnstyledCssTransition } from './UnstyledCssTransition'

import styles from './DrawerTransition.module.css'

type DrawerTransitionProps = CssTransitionProps &
  PropsWithChildren<{
    direction?: 'left'
    in: boolean
    onEnter?: () => void
    onExited?: () => void
  }>

export const DrawerTransition: FC<DrawerTransitionProps> = (props) => {
  const { children, className, direction, ...rest } = props

  return (
    <UnstyledCssTransition
      className={clsx(
        !direction && styles['drawer-transition'],
        direction === 'left' && styles['drawer-transition-left'],
        className,
      )}
      enterClassName={clsx(
        !direction && styles['drawer-transition_open'],
        direction === 'left' && styles['drawer-transition-left_open'],
      )}
      {...rest}
    >
      {children}
    </UnstyledCssTransition>
  )
}
